import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import api, { api_without_cancellation } from "../../../api/api";
import { getCoCounselError } from "../../CaseDashboard/CoCounsel/coCounsel.mjs";
import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import {
  getAge,
  formatCalendarDate,
  formatPhoneNumber,
  setCaseId,
  setClientId,
} from "../../../Utils/helper";
import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
import {
  fetchAllPages,
  fetchAllStages,
  fetchCurrentCase,
  setCaseSummary,
} from "../../../Redux/caseData/caseDataSlice";
import { fetchCaseSummary, fetchHeaderSummary } from "../../../api/case";
import { setBlurEffect } from "../../../Redux/header_blur/action";
import { setHeaderName } from "../../../Redux/header_name/action";
import { setHeaderSummary } from "../../../Redux/header/headerDataSlice";

import HIPAAComplianceForm from "./agreement-form";

// function formatFixedDate(utcString, timeZone = "America/Los_Angeles") {
//   if (!utcString) return "";

//   const date = new Date(utcString);
//   return new Intl.DateTimeFormat("en-US", {
//     timeZone,
//     year: "numeric",
//     month: "numeric",
//     day: "2-digit",
//   }).format(date);
// }

function CoCounsellingReviewModal({ show, handleClose, inviteData, fetchInvites }) {
  // const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const loggedInInfo = useSelector((state) => state.loggedInfo.loggedInInfo);

  const [dateTime, setDateTime] = useState("");
  const [dateTimeApi, setDateTimeApi] = useState("");
  const [dateTimeWithZone, setDateTimeWithZone] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [inviteError, setInviteError] = useState("");
  const [deciding, setDeciding] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const now = new Date();

    // For UI display
    const localDateTime = now.toLocaleString();

    // ISO string for accepted_at
    const isoDateTime = now.toISOString();

    // Timezone name for timezone field
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

    setDateTime(localDateTime);
    setDateTimeApi(isoDateTime); // Used for `accepted_at`
    setDateTimeWithZone(timezoneName); // Used for `timezone`
  }, []);

  const [showRejectionMessage, setShowRejectionMessage] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");
  const dispatch = useDispatch();

  const handleAccept = async (e) => {
    e.preventDefault();
    if (deciding) return;
    setDeciding(true);
    setInviteError("");
    try {
      const data = {
        link_id: inviteData?.link_id,
        decision: true,
        timestamp: dateTimeApi,
        accepted_user_ip: loggedInInfo?.ip_address,
        timezone: dateTimeWithZone,
      };

      const response = await api_without_cancellation.post(
        "/api/decide-firm-counsel-invites/",
        data
      );

      const data2 = await response.data;

      if (response.status === 200 || response.status === 201) {
        fetchInvites();
        handleClose();

        if (data2?.client_id && data2?.case_id) {
          e.preventDefault();

          dispatch(setComponentLoadingEffect("medicalProviders", true));

          dispatch(setComponentLoadingEffect("detailBar", true));
          const clientID = data2?.client_id;
          const caseID = data2?.case_id;
          await api.get(`/api/switch_client/${clientID}/${caseID}/1/`);

          setClientId(clientID);
          setCaseId(caseID);
          dispatch(fetchCurrentCase(clientID, caseID));
          dispatch(fetchAllStages());

          fetchHeaderSummary(clientID, caseID)
            .then((data) => {
              dispatch(setHeaderSummary(data));
            })
            .catch(() => {});

          fetchCaseSummary(clientID, caseID)
            .then((data) => {
              dispatch(setCaseSummary(data));
              dispatch(fetchAllPages(caseID));
              dispatch(setBlurEffect(false));
              dispatch(setHeaderName("Case"));
              document.body.classList.remove("modal-open", "has-blurred-bg");
              const menuContainer = document.getElementById("padding-top-165");
              if (menuContainer) {
                menuContainer.style.filter = "";
              }
              const divToRemove = document.querySelector(".header-blur-show");
              if (divToRemove) {
                document.body.removeChild(divToRemove);
              }
              navigate(`/bp-case/${clientID}/${caseID}`, {
                replace: true,
              });
            })
            .catch((err) => {
              console.error("Error fetching case summary:", err);
            });
        }
      }
    } catch (error) {
      setInviteError(getCoCounselError(error, "Unable to accept the invitation."));
    } finally {
      setDeciding(false);
      setShowRejectionMessage(false);
    }
  };

  const handleRejectSubmitted = async () => {
    if (deciding) return;
    setDeciding(true);
    setInviteError("");
    try {
      const data = {
        link_id: inviteData?.link_id,
        decision: false,
        timestamp: dateTimeApi,
        accepted_user_ip: loggedInInfo?.ip_address,
        timezone: dateTimeWithZone,
        reason: rejectionMessage,
      };

      const response = await api_without_cancellation.post(
        "/api/decide-firm-counsel-invites/",
        data
      );

      if (response.status === 200) {
        fetchInvites();
        handleClose();
      }
    } catch (error) {
      setInviteError(getCoCounselError(error, "Unable to reject the invitation."));
    } finally {
      setDeciding(false);
    }
  };

  const handleReject = () => {
    setShowRejectionMessage(true);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="max-1080-review-modal modal-dialog-centered "
        contentClassName="custom-modal-new-provider"
        size="md"
      >
        <div style={{ minHeight: "210px" }}>
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Accept Invite Modal
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ minHeight: "150px", padding: "0px" }}>
            {inviteError && (
              <div className="alert alert-danger m-2" role="alert">
                {inviteError}
              </div>
            )}
            <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
              <Col md={12} className="p-0">
                <div
                  className="row mx-0  custom-margin-bottom"
                  style={{
                    gap: "5px",
                  }}
                >
                  <table
                    className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25 mt-0"
                    id="treatment-summary-table"
                    style={{ width: "100%" }}
                  >
                    <thead
                      style={{
                        position: "relative",
                        top: "0",
                      }}
                    >
                      <tr id="tb-header">
                        <th />
                        <th className="">Referral</th>

                        <th className="" />
                        <th className="text-center color-grey-2">Referring Attorney </th>
                        <th className="" />
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        overflowY: "auto",
                        scrollbarWidth: "none",
                      }}
                    >
                      <tr
                        className={" height-25"}
                        id=""
                        data-table_id={36}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <td />

                        <td
                          id="padding-top-new-incoming-referrals"
                          className="p-t-5 p-b-5 td-autosize  color-black"
                          style={{ fontWeight: "600" }}
                        >
                          <div
                            className="d-flex height-21 align-items-center "
                            style={{
                              // height: "25px",

                              color: "black",
                              fontWeight: "600",
                              gap: "5px",
                            }}
                          >
                            {inviteData?.client?.profile_pic_19p ? (
                              <span className="ic-avatar ic-19 has-cover-img sidebar-pic">
                                <img
                                  src={inviteData?.client?.profile_pic_19p}
                                  alt={inviteData?.client?.first_name}
                                />
                              </span>
                            ) : (
                              <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img sidebar-pic" />
                            )}
                            {`${inviteData?.client?.first_name},`} {inviteData?.client?.last_name}
                          </div>
                          <div
                            className="d-flex height-21 align-items-center justify-content-start"
                            style={{
                              gap: "5px",
                            }}
                          >
                            <span className="d-flex align-items-center justify-content-center ic ic-19">
                              <img
                                src={birthdayIcon}
                                className="ic ic-19 d-flex align-items-center justify-content-center"
                              />
                            </span>
                            {formatCalendarDate(inviteData.client?.birthday)},
                            <span
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                color: "var(--primary)",
                              }}
                            >
                              Age
                            </span>
                            {getAge(inviteData.client?.birthday)}
                          </div>
                          <div
                            style={{
                              gap: "5px",
                            }}
                            className="d-flex height-21 align-items-center justify-content-start"
                          >
                            <span className="d-flex align-items-center justify-content-center ic ic-19">
                              <img
                                src={inviteData?.case_type?.casetype_icon}
                                className="ic ic-19 d-flex align-items-center justify-content-center"
                              />
                            </span>
                            {inviteData?.case_type?.name}
                          </div>
                          <div
                            style={{
                              gap: "5px",
                            }}
                            className="d-flex height-21 align-items-center justify-content-start"
                          >
                            <span className="d-flex align-items-center justify-content-center ic ic-19">
                              <img
                                src={incidentIcon}
                                className="ic ic-19 d-flex align-items-center justify-content-center"
                              />
                            </span>
                            {formatCalendarDate(inviteData.incident_date)}
                          </div>
                        </td>

                        <td />

                        <td
                          id="padding-top-new-incoming-referrals"
                          className="td-autosize  color-black"
                          style={{ fontWeight: "600" }}
                        >
                          <div className="d-flex height-21 align-items-center justify-content-start">
                            {inviteData?.attorney_office_name}
                          </div>
                          <div className="d-flex height-21 align-items-center justify-content-start">
                            {formatPhoneNumber(inviteData?.attorney_phone)}
                          </div>
                          <div className="d-flex height-21 align-items-center justify-content-start">
                            {inviteData?.attorney_email}
                          </div>
                        </td>

                        <td />
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>

            <HIPAAComplianceForm setIsAgreed2={setIsAgreed} />

            <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
              <Col md={12} className="p-0">
                <div
                  className="row mx-0 align-items-center custom-margin-bottom"
                  style={{
                    gap: "5px",
                  }}
                >
                  <div
                    className="col-md-3 ps-0 text-center  pe-0 d-flex align-items-center"
                    style={{
                      gap: "5px",
                    }}
                  >
                    {loggedInInfo?.user?.profile_pic ? (
                      <span className="ic-avatar ic-19 has-cover-img sidebar-pic">
                        <img
                          src={loggedInInfo?.user?.profile_pic}
                          alt={loggedInInfo?.user?.first_name}
                        />
                      </span>
                    ) : (
                      <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img sidebar-pic" />
                    )}
                    {loggedInInfo?.user?.first_name} {loggedInInfo?.user?.last_name}
                  </div>

                  <div className="col-md-2 ps-0 text-center height-25 pe-0 d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control height-25"
                      value={dateTime}
                      readOnly
                    />

                    {/* Hidden input for backend */}
                    <input type="hidden" name="dateTimeWithZone" value={dateTimeWithZone} />
                  </div>

                  <div
                    className="col-md-2 ps-0 height-25 text-center pe-0 d-flex align-items-center"
                    //   style={{ gap: "5px" }}
                  >
                    {/* Visible IP input */}
                    <input
                      type="text"
                      className="form-control"
                      value={loggedInInfo?.ip_address || ""}
                      readOnly
                    />
                  </div>

                  <div
                    className="col-md-4 ps-0 justify-content-end pe-0 d-flex align-items-center"
                    style={{
                      minWidth: "430px",
                    }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ gap: "5px" }}
                    >
                      <Button
                        variant={showRejectionMessage ? "secondary" : "success"}
                        className={`btn height-25 d-flex align-items-center justify-content-center ${
                          showRejectionMessage ? "disabled-like" : ""
                        }`}
                        disabled={!isAgreed || deciding}
                        onClick={handleAccept}
                        style={{
                          width: "74px",
                          minWidth: "74px",
                        }}
                      >
                        Accept
                      </Button>

                      <Button
                        variant={showRejectionMessage ? "danger" : "secondary"}
                        className={`btn height-25 d-flex align-items-center justify-content-center ${
                          !showRejectionMessage ? "disabled-like" : ""
                        }`}
                        disabled={!isAgreed || deciding}
                        style={{
                          width: "74px",
                          minWidth: "74px",
                        }}
                        onClick={handleReject}
                      >
                        Reject
                      </Button>
                    </div>

                    {/* {showRejectionMessage && (
                      <textarea
                        className="form-control mt-2"
                        rows={3}
                        placeholder="Enter rejection message..."
                        value={rejectionMessage}
                        onChange={(e) => setRejectionMessage(e.target.value)}
                      />
                    )} */}
                  </div>
                </div>
              </Col>
            </Row>

            {showRejectionMessage && (
              <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-12 ps-0 text-center  pe-0">
                      <textarea
                        className="form-control"
                        rows={3}
                        placeholder="Enter rejection message..."
                        value={rejectionMessage}
                        onChange={(e) => setRejectionMessage(e.target.value)}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </Modal.Body>

          {showRejectionMessage && (
            <Modal.Footer
              className="p-0 mt-0 padding-outside-btn-new-provider"
              style={{ borderTop: "none" }}
            >
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                variant="secondary"
                onClick={() => handleClose(false)}
              >
                Cancel
              </Button>
              <Button
                variant={rejectionMessage.trim() ? "success" : "secondary"}
                disabled={rejectionMessage.trim() === "" || deciding}
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                style={{
                  width: "73px",
                  minWidth: "73px",
                }}
                onClick={handleRejectSubmitted}
              >
                Submit
              </Button>
            </Modal.Footer>
          )}
        </div>
      </Modal>
    </>
  );
}

export default React.memo(CoCounsellingReviewModal);
